//application actions
export const APPLICATION_STATE_CHANGED = 'APPLICATION_STATE_CHANGED';
export const APPLICATION_ERROR_CHANGED = 'APPLICATION_ERROR_CHANGED';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const CURRENT_EVENT_SELECTED = 'CURRENT_EVENT_SELECTED';

//events actions
export const ADD_EVENT = 'ADD_EVENT';

//registration actions
export const SET_REGISTRATION = 'SET_REGISTRATION';
export const SET_REGISTRATION_STATUS = 'SET_REGISTRATION_STATUS';
export const RECORD_EARLY_DEPOSIT = 'RECORD_EARLY_DEPOSIT';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const SET_PERSONAL_INFO = 'SET_PERSONAL_INFO';
export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const UPDATE_SCHOLARSHIP = 'UPDATE_SCHOLARSHIP';
export const ADD_PAYMENT = 'ADD_PAYMENT';
export const SET_PROMOTIONS = 'SET_PROMOTIONS';

//application state
export const LOADING = 'LOADING';
export const LOADED = 'LOADED';
export const PAYMENT_PROCESSING = 'PAYMENT_PROCESSING';

//OAuth providers
export const GOOGLE_OAUTH_PROVIDER = 'GOOGLE_OAUTH_PROVIDER';
export const FACEBOOK_OAUTH_PROVIDER = 'FACEBOOK_OAUTH_PROVIDER';

//Payment types
export const PAYPAL = 'PAYPAL';
export const CHECK = 'CHECK';

//user profile fields
export const FIRST_NAME_FIELD = 'first_name';
export const LAST_NAME_FIELD = 'last_name';
